import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { TimelineMax } from 'gsap';
import barba from '@barba/core';
import App from './App';
import Menu from './Menu';
import Video from './Video';
import jQuery from 'jquery';
import Store from './Store';
import Visit from './Visit';
import Belong from './Belong';
import Wines from './Wines';
import Legacy from './Legacy';
import Home from './Home';
import CustomExp from './CustomExp';
import Commerce7 from './Commerce7';

// Register GSAP plugins
gsap.registerPlugin(ScrollToPlugin);

const Trans = {
  pageDest: '',
  pageHref: '',

  linkBehavior: function () {
    jQuery(document).on('click', 'a', function (e) {
      if (jQuery(this).attr('data-pagetype') == 'secondary') {
        App.dataTrans = 'curtainToSecondary';
      } else if (
        jQuery(this).attr('data-pagetype') == 'primary' &&
        jQuery(this).attr('data-trans') == 'primary-jump'
      ) {
        Trans.pageHref = jQuery(this).attr('href');
        Trans.pageDest = jQuery(this).attr('data-pageDest');
        App.dataTrans = 'jumpToPrimary';
      } else if (jQuery(this).attr('data-pagetype') == 'primary') {
        App.dataTrans = 'menuToPage';
      } else {
        App.dataTrans = 'catchAll';
      }
    });
  },

  initTransitions: function () {
    // DISABLED: Barba.js is disabled due to conflicts with Commerce7
    console.log('Barba.js is disabled due to conflicts with Commerce7');

    // Instead of using Barba.js transitions, we're using standard page navigation
    // Original Barba.js initialization code is commented out below

    /*
    try {
      // Debug barba elements
      const barbaWrapper = document.querySelector('[data-barba="wrapper"]');
      const barbaContainer = document.querySelector('[data-barba="container"]');

      console.log(
        'Looking for Barba wrapper with data-barba="wrapper": ',
        barbaWrapper ? 'Found' : 'Not Found'
      );
      console.log(
        'Looking for Barba container with data-barba="container": ',
        barbaContainer ? 'Found' : 'Not Found'
      );

      if (barbaWrapper) {
        console.log('Barba wrapper details:', {
          id: barbaWrapper.id,
          classList: Array.from(barbaWrapper.classList),
          childNodes: barbaWrapper.childNodes.length,
        });
      }

      if (barbaContainer) {
        console.log('Barba container details:', {
          classList: Array.from(barbaContainer.classList),
          namespace: barbaContainer.getAttribute('data-namespace'),
        });
      }

      // Initialize barba with modern API
      barba.init({
        // In v2, we don't need to specify selectors if we use data-barba attributes
        // However we'll include them for clarity
        // These should match the data-barba attributes we added
        transitions: [
          ...
        ],
        // Register page-specific hooks from Store
        views: [
          ...
        ],
      });

      // Debug output
      console.log('Barba.js initialized successfully');
    } catch (error) {
      console.error('Error initializing Barba.js:', error);
    }
    */
  },

  init: function () {
    // DISABLED: Barba.js initialization is disabled
    console.log('Barba.js initialization is disabled due to conflicts with Commerce7');

    // Instead of initializing Barba, we'll just set up basic click handlers
    this.linkBehavior();

    // Override all links with data-barba attributes to use standard navigation
    jQuery('a[data-barba]').each(function () {
      jQuery(this).removeAttr('data-barba');
    });

    // Original init code commented out below
    /*
    try {
      this.linkBehavior();
      this.initTransitions();
    } catch (error) {
      console.error('Error in Barba.js initialization:', error);
    }
    */
  },
};

export default Trans;
